import React, { Component } from 'react';
import classNames from 'classnames';
import { Tooltip } from 'components/antd';

import styles from './TooltipCell.module.scss';

interface Props {
	tooltipTitle: React.ReactNode;
	lineType: 'alert' | 'success';
	linePosition?: 'left' | 'right' | 'center';
	showTooltip?: boolean;
	placement?: any;
	className?: string;
}

export default class TooltipCell extends Component<Props> {
	render() {
		const {
			tooltipTitle,
			showTooltip,
			linePosition,
			lineType,
			placement,
			className,
		} = this.props;

		const statusLinePosition = linePosition || 'left';

		return (
			<div className={classNames(styles.tooltipCell, className)}>
				{showTooltip ? (
					<Tooltip title={showTooltip && tooltipTitle} placement={placement || 'right'}>
						<span
							className={classNames(
								styles.line,
								styles[lineType],
								styles[`line-${statusLinePosition}`]
							)}
						/>
						{this.props.children}
					</Tooltip>
				) : (
					<div className={styles.noTooltip}>{this.props.children}</div>
				)}
			</div>
		);
	}
}
